export enum CurrencyEnum {
  TON = 'ton',
  EUR = 'eur',
}
